/**
 * m.2.4 P&L kocka - explorer: izgled ekonomskog explorera (2.2) nad izvedenim osima kocke (2.3).
 * Grupira i drila po sektor / kanal / metal / MT (App\Support\PlCube\V23\Layers::keyExpr), drill
 * tvrtka -> sektor -> MT -> dokument, bez intercompany toggla (profit() sam radi ic-out u grupnom pogledu).
 * Podaci: /api/pl-cube/meta (godine) i /api/pl-cube/profit (P&L po jednoj osi). Crno-bijelo, Arial.
 */
import { useEffect, useState } from 'react';
import { api } from '../shared/api';
import { UpravaEkonExplorer, type EkonMode } from './upravaEkonExplorer';

type Locale = 'hr' | 'en';
type Props = { token: string; locale: Locale; onExit: () => void };
type Meta = { years?: number[] };

export function PlCube24Module({ token, locale, onExit }: Props) {
    const [year, setYear] = useState(2026);
    const [mode, setMode] = useState<EkonMode>('ekon');
    const [years, setYears] = useState<number[]>([2026]);

    useEffect(() => {
        let live = true;
        api<Meta>(`/pl-cube/meta?year=${year}&mode=${mode}`, token)
            .then((m) => { if (live && m?.years?.length) setYears(m.years); })
            .catch(() => { /* meta nije nuzna za rad; godina ostaje zadana */ });
        return () => { live = false; };
    }, [token, year, mode]);

    return (
        <UpravaEkonExplorer
            token={token}
            locale={locale}
            year={year}
            mode={mode}
            years={years}
            onYear={setYear}
            onMode={setMode}
            onExit={onExit}
            derived
        />
    );
}

export default PlCube24Module;
